import { PUBLIC_ROUTES } from '@lib/constants/routes.generated';

function resolveFetchUrl(input: RequestInfo | URL): URL | null {
  if (typeof window === 'undefined') return null;

  try {
    if (input instanceof Request) {
      return new URL(input.url, window.location.href);
    }
    if (input instanceof URL) {
      return new URL(input.toString(), window.location.href);
    }
    return new URL(input, window.location.href);
  } catch {
    return null;
  }
}

function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some(regex => regex.test(pathname));
}

/** Resolved same-origin fetch URL, or null when input is invalid. */
export function pathnameOfFetchInput(
  input: RequestInfo | URL
): string | undefined {
  return resolveFetchUrl(input)?.pathname;
}

/** Same-origin `/api/**` traffic the authed-fetch observer should tag. */
export function isSameOriginApiFetch(input: RequestInfo | URL): boolean {
  const parsed = resolveFetchUrl(input);
  if (!parsed) return false;
  if (parsed.origin !== window.location.origin) return false;
  return parsed.pathname.startsWith('/api/');
}

/**
 * Returns true when a client `fetch` to this input should carry a Clerk
 * Bearer token: same-origin, under `/api/`, and not on the generated public
 * allowlist.
 */
export function shouldAttachBearer(input: RequestInfo | URL): boolean {
  const parsed = resolveFetchUrl(input);
  if (!parsed) return false;
  if (parsed.origin !== window.location.origin) return false;
  if (!parsed.pathname.startsWith('/api/')) return false;
  if (isPublicRoute(parsed.pathname)) return false;
  return true;
}
